import { defineStore } from 'pinia'
import type { IEmailParticipants } from "@/types";

interface IState {
  emailTos: string | string[];
  memberIds : string | string[];
}

export const useEmailStore = defineStore({
  id: "emailStore",
  state: (): IState => ({
    emailTos: '',
    memberIds: '',
  }),
  actions: {
    emailParticipationsParams(selectedItem: any) {
      this.emailTos = selectedItem.map((item : any) => item.guardianEmail);
      this.memberIds = selectedItem.map((item: any) => item.memberUID);
    },

    async sendEmailToParticipants(request: IEmailParticipants): Promise<void> {
      return await this.axiosFactory
        .withoutToken()
        .post(`/api/email/SendEmailToParticipants`, request)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error("Email to Select Participants Failed", error);
        });
    },
    
    async sendParticipationActivationSystemEmail(): Promise<number> {
      return await this.axiosFactory
        .withoutToken()
        .post(`/api/email/SendParticipationActivationSystemEmail`)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error("Send Participation Activation System Email Failed", error);
        });
    },
  }
});